/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import connect from "react-redux/es/connect/connect"
import {FormattedMessage, injectIntl} from "react-intl";
import {Select, Tooltip, Grid} from "@scuf/common";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";

class VariantSelectors extends React.Component {
    constructor(props) {
        super(props)
        this.renderVariants = this.renderVariants.bind(this);
        this.renderSingleVariantType = this.renderSingleVariantType.bind(this)
    }

    renderSingleVariantType(variants, variantType, selectedVariant, key) {
        const {intl, userProfile} = this.props

        // Check if data for HDA environment are fulfilled
        let flag = 0;
            variants.forEach(v => {
                if (v.engineModel != null && v.platform != null) {
                    flag++;
                }
            });

        // If all variants are having HDA configuration and user is HDA user - flag for HDA environment
        if (flag === variants.length && userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            const possibleVariantsForEngineType = variants
            const engineType = Array.from(new Set(possibleVariantsForEngineType.map(v => v.engineType)));
            engineType.sort();
            const engineTypesForSelect = engineType.map((e, i) => {
                return {value: i, text: e}
            })
            const possibleVariantsForEngineModel = this.props.engineType == null ? possibleVariantsForEngineType : possibleVariantsForEngineType.filter(v => v.engineType === this.props.engineType)
            const engineModels = Array.from(new Set(possibleVariantsForEngineModel.map(v => v.engineModel)));
            engineModels.sort();
            const engineModelsForSelect = engineModels.map((e, i) => {
                return {value: i, text: e}
            })
            if (this.props.engineType != null && this.props.engineModel == null && engineModels.length === 1) {
                this.props.onEngineModelChange(engineModelsForSelect[0].text)
            }
            const possibleVariantsForConfiguration = this.props.engineModel == null ? possibleVariantsForEngineModel : possibleVariantsForEngineModel.filter(v => v.engineModel === this.props.engineModel)
            const config = new Set(possibleVariantsForConfiguration.map(v => v.configuration));
            let configurationsForSelect;
            if (config.size > 0) {
                const configuration = Array.from(config)
                configuration.sort();
                configurationsForSelect = configuration.map((c, i) => {
                    return {value: i, text: c}
                })
            } else {
                configurationsForSelect = null;
            }
            if (this.props.engineModel != null && this.props.configuration == null && config.size === 1) {
                this.props.onConfigurationChange(configurationsForSelect[0].text)
            }
            const possibleVariantsForPlatforms = this.props.configuration == null ? possibleVariantsForConfiguration : possibleVariantsForConfiguration.filter(v => v.configuration === this.props.configuration || v.configuration == null)
            const platforms = Array.from(new Set(possibleVariantsForPlatforms.map(v => v.platform)));
            platforms.sort();
            const platformsForSelect = platforms.map((p, i) => {
                return {value: i, text: p}
            })
            if ((this.props.configuration != null && this.props.platform == null && platforms.length === 1) ||
                (this.props.engineModel != null && this.props.configuration == null && config.size === 0 && this.props.platform == null && platforms.length === 1)) {
                this.props.onPlatformChange(platformsForSelect[0].text, variantType)
            }
            return (
                <Grid.Row key={key}>
                    <Grid.Column width={4} sWidth={12}>
                        <div className="engine-config">
                            <Select
                                label={intl.formatMessage({id: "admin.asset.detail.variant.engineTypes"})}
                                options={engineTypesForSelect}
                                placeholder={intl.formatMessage({id: "admin.asset.detail.variant.engineType.select"})}
                                onChange={(data) => this.props.onEngineTypeChange(engineTypesForSelect.find(e => e.value === data).text)}
                                fluid
                                value={this.props.engineType == null ? null : engineTypesForSelect.find(e => e.text === this.props.engineType).value}
                                error={this.props.getErrorMessage(['engineType'])}
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column width={4} sWidth={12}>
                        <div className="engine-config">
                            <Select
                                label={intl.formatMessage({id: "admin.asset.detail.variant.engineModels"})}
                                options={engineModelsForSelect}
                                placeholder={intl.formatMessage({id: "admin.asset.detail.variant.engineModel.select"})}
                                fluid
                                disabled={this.props.engineType == null}
                                onChange={(data) => this.props.onEngineModelChange(engineModelsForSelect.find(e => e.value === data).text)}
                                value={this.props.engineModel == null ? null : engineModelsForSelect.find(e => e.text === this.props.engineModel).value}
                                error={this.props.getErrorMessage(['engineModel'])}
                            />
                        </div>
                    </Grid.Column>
                    {config.size > 0 ?
                        <Grid.Column width={4} sWidth={12}>
                            <div className="engine-config">
                                <Select
                                    label={intl.formatMessage({id: "admin.asset.detail.variant.configurations"})}
                                    options={configurationsForSelect}
                                    placeholder={intl.formatMessage({id: "admin.asset.detail.variant.configuration.select"})}
                                    fluid
                                    disabled={this.props.engineModel == null}
                                    onChange={(data) => this.props.onConfigurationChange(configurationsForSelect.find(c => c.value === data).text)}
                                    value={this.props.configuration == null ? null : configurationsForSelect.find(c => c.text === this.props.configuration).value}
                                    error={this.props.getErrorMessage(['configuration'])}
                                />
                            </div>
                        </Grid.Column>
                        :
                        <Grid.Column width={4} sWidth={12}>
                            <div className="engine-config">
                                {this.props.engineModel == null ?
                                    <Select
                                        placeholder={intl.formatMessage({id: "admin.asset.detail.variant.configuration.select"})}
                                        label={intl.formatMessage({id: "admin.asset.detail.variant.configurations"})}
                                        options={[]}
                                        fluid
                                        disabled={true}
                                    />
                                    :
                                    <Tooltip
                                        element={
                                            <div>
                                                <Select
                                                    placeholder={intl.formatMessage({id: "admin.asset.detail.variant.configuration.select"})}
                                                    label={intl.formatMessage({id: "admin.asset.detail.variant.configurations"})}
                                                    options={[]}
                                                    fluid
                                                    disabled={true}
                                                />
                                            </div>
                                        }
                                        content={intl.formatMessage({id: "admin.asset.detail.variant.configuration.notApplicable"})}
                                        position="left center"
                                        event="hover"
                                        hoverable={true}
                                    />
                                }
                            </div>
                        </Grid.Column>
                    }
                    <Grid.Column width={4} sWidth={12}>
                        <div className="engine-config">
                            <Select
                                label={intl.formatMessage({id: "admin.asset.detail.variant.platforms"})}
                                options={platformsForSelect}
                                placeholder={intl.formatMessage({id: "admin.asset.detail.variant.platform.select"})}
                                fluid
                                disabled={config.size > 0 ? this.props.configuration == null : this.props.engineModel == null}
                                onChange={(data) => this.props.onPlatformChange(platformsForSelect.find(p => p.value === data).text, variantType)}
                                value={this.props.platform == null ? null : platformsForSelect.find(p => p.text === this.props.platform).value}
                                error={this.props.getErrorMessage(['platform'])}
                            />
                        </div>
                    </Grid.Column>
                </Grid.Row>
            )
        }

        const variantOptions = this.getVariantsOptions(variants)
        return (
            <Grid.Row>
                <Grid.Column width={4} sWidth={12}>
                    <div className="form-field">
                        <Select label={variantType}
                                placeholder={intl.formatMessage({id: "admin.asset.detail.select.variant"})}
                                options={variantOptions}
                                value={selectedVariant == null ? null : selectedVariant.id}
                                error={this.props.getErrorMessage(['variants'])}
                                multiple={false}
                                search
                                fluid
                                disabled={this.props.readAccess || this.props.assetStatus === 'DISABLED'}
                                onChange={(data) => this.props.onVariantChange(data, variantType)}/>
                    </div>
                </Grid.Column>
            </Grid.Row>
        )
    }

    renderVariants(variants, selectedVariants) {
        if (variants == null) {
            return (
                <Grid.Row>
                    <Grid.Column width={4} sWidth={12}>
                        <FormattedMessage id="admin.asset.variants.empty"/>
                    </Grid.Column>
                </Grid.Row>
            )
        }
        // Get variant types
        const keys = [...variants.keys()];
        // Order them alphabetically, to be shown in same order on UI all the time
        keys.sort();
        if (keys.length === 0) {
            return (
                <Grid.Row>
                    <Grid.Column width={4} sWidth={12}>
                        <FormattedMessage id="admin.asset.variants.empty"/>
                    </Grid.Column>
                </Grid.Row>
            )
        }
        return keys.map((v, i) => {
            const selectedVariant = selectedVariants.get(v)
            return this.renderSingleVariantType(variants.get(v), v, selectedVariant, i);
        })
    }

    getVariantsOptions(variants) {
        const varOptions = variants.map(
            v => {
                return {value: v.id, text: v.name}
            }
        )
        return varOptions.sort(sortVariants);
    }

    render() {
        const {variants, selectedVariants} = this.props;
        return (
            <React.Fragment>
                {this.renderVariants(variants, selectedVariants)}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        variants: ownProps != null ?
            ownProps.external === true ?
                ownProps.variants
                :
                state.assetReducer.variants
            :
            state.assetReducer.variants,
        userProfile: state.security.userProfile,
    }
}

const sortVariants = (a, b) => {
    let comparison
    if (a.text > b.text) {
        comparison = 1;
    } else if (a.text < b.text) {
        comparison = -1;
    } else {
        comparison = 0
    }
    return comparison;
}

export default injectIntl(connect(mapStateToProps, null)(VariantSelectors))